<template>
  <el-dialog
    title="帖子详情"
    :visible.sync="visible"
    width="920px"
    append-to-body
    class="post-detail-dialog-wrap"
  >
    <div v-loading="loading" class="post-detail-dialog">
      <div class="detail-header">
        <div class="title-wrap">
          <div class="title-row">
            <h3>{{ detail.contentTitle || '帖子详情' }}</h3>
            <el-tag size="small" :type="stateTagType">{{ stateText }}</el-tag>
          </div>
          <div class="meta-line">
            <span>{{ detail.nickName || '未知用户' }}</span>
            <span>{{ typeText }}</span>
            <span>{{ detail.createTime || '--' }}</span>
          </div>
        </div>
        <div v-if="!readonly" class="header-actions">
          <el-button type="primary" icon="el-icon-check" size="small" plain @click="submitCtnFn(1)">通过</el-button>
          <el-button type="danger" icon="el-icon-close" size="small" plain @click="submitCtnFn(2)">下架</el-button>
        </div>
      </div>

      <div class="detail-layout">
        <section class="main-panel">
          <div class="section-title">帖子内容</div>
          <div class="content-text">
            {{ detail.contentData || '暂无内容' }}
          </div>

          <div v-if="detail.contentType == 0 && normalizedImages.length" class="media-grid">
            <el-image
              v-for="(item, index) in normalizedImages"
              :key="index"
              class="post-image"
              :src="item"
              fit="cover"
              :preview-src-list="normalizedImages"
            />
          </div>

          <div v-if="detail.contentType == 1 && detail.contentVideo" class="video-wrap">
            <video class="video-module" :src="detail.contentVideo" controls></video>
          </div>

          <div v-if="detail.contentType == 2 && detail.contentAudio" class="audio-wrap">
            <audio controls :src="detail.contentAudio"></audio>
          </div>

          <el-empty
            v-if="showEmptyMedia"
            :description="`${typeText}内容暂无可预览媒体`"
            :image-size="96"
          />
        </section>

        <aside class="side-panel">
          <div class="info-card">
            <div class="info-card-header">
              <div>
                <div class="info-title">基础信息</div>
                <div class="info-subtitle">帖子归属与发布信息</div>
              </div>
              <el-tag size="mini" effect="dark">{{ typeText }}</el-tag>
            </div>
            <div class="info-list">
              <div class="info-item primary">
                <span class="info-label">用户昵称</span>
                <span class="info-value">{{ detail.nickName || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">所属圈子</span>
                <span class="info-value">{{ detail.circleName || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">话题名称</span>
                <span class="info-value">{{ detail.contentSubject || '--' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">发布时间</span>
                <span class="info-value">{{ detail.createTime || '--' }}</span>
              </div>
            </div>
          </div>

          <div class="section-title audit-title">审核信息</div>
          <div class="audit-status">
            <span>当前状态</span>
            <el-tag size="small" :type="stateTagType">{{ stateText }}</el-tag>
          </div>
          <div v-if="showRejectReason" class="reject-reason">
            <div class="reject-label">下架理由</div>
            <div class="reject-content">{{ detail.examineResult || '--' }}</div>
          </div>
        </aside>
      </div>
    </div>

    <el-dialog
      title="请输入下架理由"
      :visible.sync="rejectVisible"
      width="420px"
      append-to-body
      center
    >
      <el-input v-model="submitData.examineResult" placeholder="请输入下架内容" :rows="4" type="textarea"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReject">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { postStateText, isPostUnderReview } from '@/utils/postStatus'
import { GetContentDetailsData } from '@/api/user'
import { saveOrUpdateApi } from '@/api/virtual'

export default {
  name: 'PostDetailDialog',
  data() {
    return {
      visible: false,
      loading: false,
      readonly: false,
      rejectVisible: false,
      detail: {},
      submitData: {},
      examineTemplates: {
        1: '帖子内容正常，审核通过。',
        2: '帖子内容不符合平台规范，已下架处理。'
      }
    }
  },
  computed: {
    typeText() {
      const typeMap = {
        0: '图文',
        1: '视频',
        2: '语音'
      }
      return typeMap[this.detail.contentType] || '未知'
    },
    stateText() {
      return postStateText(this.detail)
    },
    stateTagType() {
      if (isPostUnderReview(this.detail)) return 'warning'
      const state = this.detail.contentState
      if (state == 1) return 'success'
      if (state == 4) return 'info'
      if (state == 2 || state == 3) return 'danger'
      return 'warning'
    },
    normalizedImages() {
      const images = this.detail.contentImg
      if (!images) return []
      if (Array.isArray(images)) return images.filter(Boolean)
      if (typeof images === 'string') {
        return images.split(',').map(item => item.trim()).filter(Boolean)
      }
      return []
    },
    showRejectReason() {
      return this.detail.contentState == 2 || this.detail.contentState == 3 || this.detail.contentState == 4
    },
    showEmptyMedia() {
      if (this.detail.contentType == 0) return !this.normalizedImages.length
      if (this.detail.contentType == 1) return !this.detail.contentVideo
      if (this.detail.contentType == 2) return !this.detail.contentAudio
      return false
    }
  },
  methods: {
    open(rowOrId, options = {}) {
      const fallback = typeof rowOrId === 'object' && rowOrId !== null ? { ...rowOrId } : {}
      const contentId = typeof rowOrId === 'object' && rowOrId !== null ? rowOrId.contentId : rowOrId
      this.visible = true
      this.readonly = Boolean(options.readonly)
      this.rejectVisible = false
      this.detail = fallback
      this.submitData = { ...fallback }

      if (!contentId) {
        this.loading = false
        return
      }

      this.loading = true
      GetContentDetailsData(contentId).then(res => {
        if (res.code == 200 && res.data) {
          this.detail = { ...fallback, ...res.data }
          this.submitData = { ...this.detail }
        } else if (res.msg) {
          this.$message.warning(res.msg)
        }
      }).catch(() => {
        this.$message.warning('帖子详情获取失败，已展示列表中的信息')
      }).finally(() => {
        this.loading = false
      })
    },
    submitCtnFn(val) {
      if (!this.detail.contentId) {
        this.$message.warning('缺少帖子信息，无法提交审核')
        return
      }

      this.submitData = {
        ...this.detail,
        contentState: val,
        examineResult: this.getInitialExamineResult(val)
      }
      if (val == 2) {
        this.rejectVisible = true
        return
      }
      this.savePost()
    },
    submitReject() {
      this.submitData.contentState = 2
      if (!this.submitData.examineResult) {
        this.submitData.examineResult = this.getInitialExamineResult(2)
      }
      this.savePost()
    },
    getInitialExamineResult(state) {
      if (this.detail.contentState == 0) {
        return this.examineTemplates[state] || ''
      }
      return this.detail.examineResult || ''
    },
    savePost() {
      saveOrUpdateApi(this.submitData).then(res => {
        if (res.code == 200) {
          this.detail = { ...this.detail, ...this.submitData }
          this.$message.success('保存成功')
          this.rejectVisible = false
          this.visible = false
          this.$emit('success', { ...this.detail })
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(err => {
        this.$message.error(err || '保存失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.post-detail-dialog {
  min-height: 180px;
}

.detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.title-wrap {
  min-width: 0;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;

  h3 {
    margin: 0;
    max-width: 560px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
  }
}

.meta-line {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-top: 10px;
  color: #909399;
  font-size: 13px;
}

.header-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 16px;
  align-items: start;
}

.main-panel,
.side-panel {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 18px;
  box-sizing: border-box;
}

.section-title {
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.content-text {
  min-height: 96px;
  padding: 14px;
  margin-bottom: 18px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
  color: #303133;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.post-image {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-sizing: border-box;
}

.video-wrap {
  max-width: 720px;
}

.video-module {
  width: 100%;
  max-height: 520px;
  border-radius: 6px;
  background: #000;
}

.audio-wrap {
  padding: 18px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;

  audio {
    width: 100%;
  }
}

.info-card {
  overflow: hidden;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  background: #f4f9ff;
}

.info-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: #ecf5ff;
  border-bottom: 1px solid #d9ecff;
}

.info-title {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.info-subtitle {
  margin-top: 4px;
  color: #6094c7;
  font-size: 12px;
}

.info-list {
  padding: 8px 14px 14px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #e4effb;

  &:last-child {
    border-bottom: 0;
  }
}

.info-item.primary {
  align-items: center;
  margin: 6px 0 2px;
  padding: 12px;
  background: #fff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.info-label {
  flex-shrink: 0;
  color: #7a8ca3;
  font-size: 13px;
}

.info-value {
  color: #303133;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

.audit-title {
  margin-top: 22px;
}

.audit-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  color: #606266;
}

.reject-reason {
  margin-top: 12px;
  padding: 12px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
}

.reject-label {
  margin-bottom: 8px;
  color: #f56c6c;
  font-weight: 600;
}

.reject-content {
  color: #606266;
  line-height: 1.6;
  word-break: break-word;
}

@media (max-width: 1100px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }

  .detail-header {
    flex-direction: column;
  }

  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
